import axios from 'axios';
import { HASTRA_APP_URI, HUSTRA_CHAT_URI } from '../Config/Config';

//create amazon chime room 
export async function createAmzonChimeMeeting(meetingTitle){
    try{
        const res = await axios.get(HUSTRA_CHAT_URI + '/hastra/create-meeting?title='+meetingTitle); 
        return res;
    }catch(e){
        console.log(e)
    }
}

//join meeting room
export async function joinMeetingRoom(data){ 
    return await axios.post(HUSTRA_CHAT_URI + 'join-meeting', data);    
}


export async function getLocalData(){
    try{
        const res = await axios.get('/patient.json'); 
        return res;
    }catch(e){
        console.log(e)
    }
}

//register api
export async function register(data){ 
    return await axios.post(HASTRA_APP_URI + '/register', data);    
}

//login api
export async function login(data){ 
    return await axios.post(HASTRA_APP_URI + '/login', data);    
}

//profile update api
export async function profileUpdate(data){ 
    return await axios.post(HASTRA_APP_URI + '/personal-details', data,{
        headers: {
            Authorization: localStorage.getItem("doctor_jwt_token")
        }
    });    
}

//profile update api
export async function myAssignmentList(data){ 
    return await axios.post(HASTRA_APP_URI + '/assignment-list', data,{
        headers: {
            Authorization: localStorage.getItem("doctor_jwt_token")
        }
    });    
}


//get patient list
export async function patinetList(data){ 
    return await axios.post(HASTRA_APP_URI + '/patient-list', data,{
        headers: {
            Authorization: localStorage.getItem("doctor_jwt_token")
        }
    });    
}

//get video call list
export async function videoCallsList(data){ 
    return await axios.get(HASTRA_APP_URI + '/video-calls',{
        headers: {
            Authorization: localStorage.getItem("doctor_jwt_token")
        }
    });    
}

//video call store
export async function videoCallStore(data){ 
    return await axios.post(HASTRA_APP_URI + '/video-calls', data,{
        headers: {
            Authorization: localStorage.getItem("doctor_jwt_token")
        }
    });    
}

//video call delete
export async function videoCallDelete(data){ 
    return await axios.delete(HASTRA_APP_URI + '/video-calls',{
        headers: {
            Authorization: localStorage.getItem("doctor_jwt_token")
        },
        data
    });    
}

//video call start
export async function videoCallStart(data){ 
    return await axios.post(HASTRA_APP_URI + '/video-call-start', data,{
        headers: {
            Authorization: localStorage.getItem("doctor_jwt_token")
        }
    });    
}

//get all chat messages
export async function getAllChatMessage(data){ 
    return await axios.post(HASTRA_APP_URI + '/retrieve-all-patient-message', data,{
        headers: {
            Authorization: localStorage.getItem("doctor_jwt_token")
        }
    });    
}

//store notes data
export async function storeNotes(data){ 
    return await axios.post(HASTRA_APP_URI + '/notes', data,{
        headers: {
            Authorization: localStorage.getItem("doctor_jwt_token")
        }
    });    
}


//store image data
export async function storePatientImage(data){ 
    return await axios.post(HASTRA_APP_URI + '/physician-image', data,{
        headers: {
            Authorization: localStorage.getItem("doctor_jwt_token")
        }
    });    
}

//get all images
export async function getAllPhysicianImages(data){ 
    return await axios.post(HASTRA_APP_URI + '/get-physician-images', data,{
        headers: {
            Authorization: localStorage.getItem("doctor_jwt_token")
        }
    });    
}



//encounter types
export async function storeEncounterType(data){ 
    return await axios.post(HASTRA_APP_URI + '/encounter-types', data,{
        headers: {
            Authorization: localStorage.getItem("doctor_jwt_token")
        }
    });    
}

//get encounter types
export async function getEncounterTypes(data){ 
    return await axios.post(HASTRA_APP_URI + '/get-encounter-types', data,{
        headers: {
            Authorization: localStorage.getItem("doctor_jwt_token")
        }
    });    
}
//store patient notes
export async function storePatientNotes(data){ 
    return await axios.post(HASTRA_APP_URI + '/patient-notes', data,{
        headers: {
            Authorization: localStorage.getItem("doctor_jwt_token")
        }
    });    
}
//get all patient types
export async function getAllPatientNotes(data){ 
    return await axios.post(HASTRA_APP_URI + '/get-patient-notes', data,{
        headers: {
            Authorization: localStorage.getItem("doctor_jwt_token")
        }
    });    
}


//get doctor details
export async function getPersonalData(data){ 
    return await axios.post(HASTRA_APP_URI + '/get-personal-data', data,{
        headers: {
            Authorization: localStorage.getItem("doctor_jwt_token")
        }
    });    
}


//get doctor details
export async function getCountryList(){ 
    return await axios.get('/local-data/country.json');    
}

 
export async function getInstanceImage(url){  
    return await axios.get(url,{
        headers: {
            Accept:'image/png', 
            Authorization: 'Basic YWRtaW46YWRtaW4xMjM='
        },
        responseType: 'blob',
    });  
}

export async function getInstanceData(url){ 
    return await axios.get(url,{
        headers: {
            Authorization: 'Basic YWRtaW46YWRtaW4xMjM='
        }
    });    
}

 

export async function simpleGetheader(url){ 
    return await axios.get(url);    
}



 